module.exports = __webpack_public_path__ + "img/reactlogo.1072ccea.png";